export enum CollectionType {
  COMPACT = 'compact',
  SPORTS_CAR = 'sport',
  WELCAB = 'welcab',
  MULTI_SEATER = 'multiSeater',
  VOLVO = 'volvo',
  TESLA = 'tesla',
  RV = 'rv'
}

export default CollectionType
